import { Button, Input, Modal } from "components";

type ModalExportProps = {
  isOpen: boolean
  setIsOpen: (value: { isOpen: boolean; type: "" | "excel" | "pdf"; activeTab: string | null }) => void
  title?: string
  type: "excel" | "pdf"
  total: number
  defaultAmount?: number
  onExport: (amount: number) => void
  amount: number
  setAmount: React.Dispatch<React.SetStateAction<number>>
}

export default function ModalConfirmExport({
  isOpen,
  setIsOpen,
  title = "Export Data",
  type,
  total, 
  amount = 10,
  setAmount,
  onExport,
}: ModalExportProps) {

  return (
    <Modal
      isOpen={isOpen}
      title={`EXPORT ${title.toUpperCase()}`}
      closeModal={() => setIsOpen({ isOpen: false, type: "", activeTab: null })}
    >
      <Modal.Body>
        <div className="flex flex-col items-center justify-center min-h-[220px] space-y-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-zinc-800">Export {title}</h2>
            <p className="text-sm text-zinc-500 mt-2">
              Specify how many data entries you want to export
            </p>
          </div>

          <div className="flex items-center space-x-3">
            <button
              className="w-10 h-10 rounded-full bg-zinc-100 hover:bg-zinc-200 text-zinc-600 text-lg font-bold shadow"
              onClick={() => setAmount(amount > 1 ? amount - 1 : 1)}
            >
              −
            </button>

            <Input
              type="number"
              min={1}
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
            />

            <button
              className="w-10 h-10 rounded-full bg-zinc-100 hover:bg-zinc-200 text-zinc-600 text-lg font-bold shadow"
              onClick={() => setAmount(amount < 1000 ? amount + 1 : 1000)}
            >
              +
            </button>
          </div>

          <p className="text-sm text-zinc-500">
            Total available:{" "}
            <span className="font-semibold text-zinc-800">{total}</span> entries
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          color="primary"
          onClick={() => onExport(amount)}
        >
          EXPORT {type.toUpperCase()}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}